module.exports = __webpack_public_path__ + "b9d5cea578f79f153a2805fb29ecd9e2.png";